import { render, staticRenderFns } from "./AuthorTabOverview.vue?vue&type=template&id=61a5e9e0&scoped=true&"
import script from "./AuthorTabOverview.vue?vue&type=script&lang=js&"
export * from "./AuthorTabOverview.vue?vue&type=script&lang=js&"
import style0 from "./AuthorTabOverview.vue?vue&type=style&index=0&id=61a5e9e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a5e9e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VCard,VCardText,VCardTitle,VTimeline,VTimelineItem})
